import useSelector from '../../util/hooks/useSelector';

// eslint-disable-next-line import/prefer-default-export
export const useIsGlobalNotificationOpen = (): boolean => useSelector(({ notifications }) => (
  notifications.globalNotification !== notifications.closedGlobalNotification
));
